export function getImageLimit(user) {
  const value = Number(user?.imageLimit);
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function formatImageLimit(limit) {
  return limit == null ? "No image limit" : `${limit} image${limit === 1 ? "" : "s"} limit`;
}
